export default "__VITE_ASSET__D1DS7Wz1__"